import React from 'react'
import { Box, Checkbox, FormControl, FormControlLabel } from '@mui/material'
import TextColorFontBody from 'common/Typography/TextColorFontBody'

import { IFilterField } from './CustomDataGridFilter'
import { IServerFilterField } from './CustomDataGridServerFilter'

export default function CustomFilterSection(props: customFilterSectionProps) {
  const { filterField } = props

  const handleChecked = (e) => {
    if (e.target.checked) {
      filterField.setChecked([e.target.value, ...filterField.checked])
    } else {
      const unchecked = filterField.checked.filter(
        (value) => value !== e.target.value
      )
      filterField.setChecked(unchecked)
    }
  }

  return (
    <>
      <Box sx={{ margin: '20px 16px' }}>
        <TextColorFontBody
          sx={{ fontSize: '16px', fontWeight: 500, ml: '-10px' }}
        >
          {filterField.name}
        </TextColorFontBody>
        <FormControl>
          {filterField.values.map((value, index) => {
            return value !== '(Blank)' ? (
              <FormControlLabel
                label={
                  <TextColorFontBody sx={{ fontSize: '16px', fontWeight: 400 }}>
                    {value}
                  </TextColorFontBody>
                }
                key={index}
                value={value}
                control={
                  <Checkbox
                    onChange={(e) => handleChecked(e)}
                    value={value}
                    checked={filterField.checked.includes(value)}
                    sx={{ color: 'gray' }}
                  />
                }
              />
            ) : (
              <TextColorFontBody>No selection available</TextColorFontBody>
            )
          })}
        </FormControl>
      </Box>
    </>
  )
}

interface customFilterSectionProps {
  filterField: IFilterField | IServerFilterField
}
